export interface PresetValues {
  last_7d: Value;
  last_14d: Value;
  last_30d: Value;
  last_90d: Value;
  this_month: Value;
  last_month: Value;
  this_year: Value;
  [Prop: string]: Value;
}

export type TimeStep = 'date_day'|'year_month'|'year'|'year_week'; 

interface Value {
  start: Date;
  end: Date;
  displayName: string;
  step: TimeStep;
}

interface InitialState {
  datePreset: keyof PresetValues;
  adset?: number[];
  campaign?: number[];
  adAccount?: number;
  ads?: number[];
  attributionWindow: [string | null, string | null];
  resourceTypeSelected?: string;
  timeStep: TimeStep;
  start?: number;
  end?: number;
  dateSelection: 'custom' | 'preset';
}

export const initialState: InitialState = {
  datePreset: 'last_14d',
  attributionWindow: ['7d_click', '1d_view'],
  timeStep: "date_day",
  dateSelection: 'preset',
};
